import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';

import { TokenStorageService } from '../../core/services/token-storage.service';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { logout } from '../../store/Authentication/authentication.actions';
import { AuthenticationService } from '../services/auth.service';
import { SharedService } from '../../shared/shared.service';
import { SweetAlertIcon } from '../../shared/constants/enum';
import { LoaderService } from '../services/loader.service';

const TOKEN_HEADER_KEY = 'Authorization'; // for Node.js Express back-end

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private token: TokenStorageService,
    private router: Router,
    private store: Store,
    private authenticationService: AuthenticationService,
    private sharedService: SharedService,
    private loaderService: LoaderService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if the request has the 'No-Intercept' header

    let authReq = req;
    const token = this.token.getToken();
    if (token != null) {
      // Clone the request and set the new header in one step

      if (req.headers.has('No-Intercept')) {
        const headers = req.headers.delete('No-Intercept');
        const clonedRequest = req.clone({ headers });
        return next.handle(clonedRequest);
      } else {
        authReq = req.clone({
          headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token),
        });
      }
    }
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && error.statusText === 'Unauthorized') {
          // auto logout if 401 response returned from api
          console.log('error==>', error);
          this.authenticationService.apiError();
        }
        if (error.status === 400) {
          this.sharedService.showMessageDialog(
            '',
            error.error?.message || 'Invalid request. Please check your input.',
            SweetAlertIcon.ERROR
          );
          this.loaderService.setLoading(false)
          console.log('Bad Request error:', error.error);
        }
        return throwError(error);
      })
    );
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
